import { render } from "./TechSupport.vue?vue&type=template&id=30137716"
import script from "./TechSupport.vue?vue&type=script&lang=js"
export * from "./TechSupport.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\digitaldistribution.io-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__